export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'LastName',
    'Email',
    'DataProtectionAgreement'
  ],
  'requiredFields': {
    'default': [
      'VATNumber',
      'Company'
    ],
    'consulting': [
      'VATNumber',
      'RequestTopic',
      'Company'
    ],
    'offersGeneral': [
      'VATNumber',
      'RequestTopic',
      'Company'
    ],
    'offersInvestment': [
      'VATNumber',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'VATNumber',
      'RequestTopic',
      'Company'
    ],
    'customer_serviceBank': [
      'VATNumber',
      'RequestTopic'
    ],
    'investor_relations': [
      'VATNumber',
      'RequestTopic'
    ],
    'cooperation': [
      'VATNumber',
      'RequestTopic',
      'Company'
    ],
    'other': [
      'RequestTopic',
      'RequestMessage',
    ],
    'career': [
      'RequestTopic',
      'RequestMessage'
    ]
  }
}
